import React from 'react';
import Icon from '../Icons/Icon';
import { classNames } from '../../Services/helpers';
import { recipientStatuses, typeClasses } from '../../Data/Broadcasts';

const Broadcast = ({message}) => {
    const {title, recipientStatus} = message;

    return <div className={classNames(
            'w-[80%] rounded-xl py-2 px-3 mb-3 place-self-center ',
            'border border-indigo-200 bg-indigo-50/50',
            'text-sm flex items-center justify-between',
        )}
    >
        <div className="grow flex flex-row items-center text-balance">
            <Icon icon="Bullhorn" className="mr-2" />
            {title}
        </div>
        <div>
            <div className={classNames(
                'flex items-center justify-between gap-x-2 border rounded-full py-1 px-2',
                typeClasses[recipientStatuses[recipientStatus]?.type]?.fg ?? null,
                typeClasses[recipientStatuses[recipientStatus]?.type]?.border ?? null,
                'bg-white'
            )}>
                <Icon icon={recipientStatuses[recipientStatus].icon} />
                {recipientStatus}
            </div>
        </div>
    </div>
}

export default Broadcast;